import autobind from 'autobind-decorator';
import { __, __sprintf } from '../../utils/i18n.js';
import { FormInput } from '../FormInput/FormInput.js';

function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
class FormTextInput extends FormInput {
    handleValidate(value, allValues) {
        const { required, minLength, maxLength } = this.props;
        if (required && typeof value !== "string") {
            return __("Az érték megadása kötelező!");
        }
        if (typeof value === "string" && minLength && minLength > value.length) {
            return __sprintf("A megadott érték túl rövid %s!", minLength);
        }
        if (typeof value === "string" && maxLength && maxLength < value.length) {
            return __sprintf("A megadott érték túl hosszú %s!", maxLength);
        }
        return super.handleValidate(value, allValues);
    }
}
_ts_decorate([
    autobind,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof FieldType === "undefined" ? Object : FieldType,
        Object
    ]),
    _ts_metadata("design:returntype", Object)
], FormTextInput.prototype, "handleValidate", null);

export { FormTextInput };
//# sourceMappingURL=FormTextInput.js.map
